export const Context = {
    webtexte: null,
    storageIsNotAvailable: false,
    browserIsInvalid: false,
    agencyFormRenderCounter: 0,
    showHelp: false,
};
export default Context;
